<template>
    <div>
        <img
            :src="require(`.././../../assets/images/upgrade-now@2x.png`)"
            :srcset="`${require(`../../../assets/images/upgrade-now@1x.png`)} 1x, ${require(`../../../assets/images/upgrade-now@2x.png`)} 2x, ${require(`../../../assets/images/upgrade-now@3x.png`)} 3x, ${require(`../../../assets/images/upgrade-now@4x.png`)} 4x`"
        />

        <div class="modal-body d-flex gap-20">
            <div class="icon-box">
              <strong class="d-flex align-items-center">!</strong>
              <div class="d-flex align-items-end"><CoinSVG /></div>
            </div>
            <div class="d-flex flex-column">  
                <h2>{{ 'Not Enough Credits Left' | trans }}</h2>
                <p v-html="getUpgradeText">
                </p>
                <p>{{ 'Your artistic journey awaits!' | trans }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import store from '../../../mixins/store.mixin';
import user from "../../../mixins/user.mixin";
import CoinSVG from '../../../../form/icons/CoinSVG.vue';

export default {
    name: 'RegisteredCreditLimit',
    props: {},
    components: { CoinSVG },
    mixins: [store, user],
    data() {
        return {};
    },
    methods: {},
    computed: {
      getUpgradeText() {
        return this.translate('<strong>Upgrade to our Premium subscription</strong> today and unlock the true potential of AI Image Creator Studio.');
      }
    },
};
</script>
